module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn inverse-color",
    class: {
      'btn-deep-magenta': _vm.activeVal, 'btn-midnight-blue': !_vm.activeVal, 'btn-celestial-blue': _vm.color
    },
    attrs: {
      "value": _vm.value,
      "type": this.type
    },
    on: {
      "click": function($event) {
        _vm.updateQuote(_vm.value)
      }
    }
  }, [(_vm.item) ? [(!_vm.activeVal) ? [_c('span', {
    staticClass: "ion ion-android-radio-button-off icon-spacer icon-white"
  })] : [_c('span', {
    staticClass: "ion ion-android-radio-button-on icon-spacer icon-white"
  })], _vm._v("\n      " + _vm._s(_vm.item) + "\n  ")] : [_vm._t("default")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2a8dc773"}!./src/app/components/button/button.html
// module id = 466
// module chunks = 1